import { useTranslate } from '@growtherapy/i18n';
import { Button, ButtonSizes, ButtonUseType, useRebrand } from '@growtherapy/sprout-ui';

import { PageComponentProps } from '../PaginatedDrawer';
import { MeasureSchemaAndAnswers } from './types';

export type MeasureActionsProps = Pick<PageComponentProps<MeasureSchemaAndAnswers>, 'isFirstPage' | 'isLastPage'> & {
  isLoading?: boolean;
  onNextPage: () => void;
  onPrevPage: () => void;
  size?: ButtonSizes;
  submitButtonUse?: ButtonUseType;
  submitButtonLabel?: string;
  /** Hides the "previous" button so the flow only moves forward. */
  hidePreviousButton?: boolean;
};

export function MeasuresActions({
  isFirstPage,
  isLastPage,
  isLoading,
  onNextPage,
  onPrevPage,
  size,
  submitButtonUse,
  submitButtonLabel,
  hidePreviousButton,
}: MeasureActionsProps) {
  const t = useTranslate();
  const isRebrand = useRebrand();

  return (
    <>
      {!isFirstPage && !hidePreviousButton && (
        <Button onClick={onPrevPage} use='secondary' size={size} disabled={isLoading}>
          {t('telehealth-core:core.previous')}
        </Button>
      )}
      <Button
        onClick={onNextPage}
        loading={isLoading}
        disabled={isLoading}
        size={size}
        use={submitButtonUse ?? (isRebrand ? 'secondary' : 'primary')}
      >
        {submitButtonLabel ?? (isLastPage ? t('telehealth-core:core.complete') : t('telehealth-core:core.continue'))}
      </Button>
    </>
  );
}
